(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["marquee"] && !Shopify.designMode) return;
  try {
    class MarqueeBlock extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.currentIndex = 0;
      this.marqueeElements = this.children;

      let animationDelay = 1.2;
      if (this.dataset.animationDelay) {
        animationDelay = this.dataset.animationDelay;
      }
      animationDelay = +animationDelay;
      animationDelay = animationDelay * 1000;

      setInterval(() => this.scrollText(), animationDelay);
    }

    scrollText() {
      const element = this.marqueeElements[this.currentIndex];

      const nextElement =
        this.currentIndex === this.marqueeElements.length - 1
          ? this.marqueeElements[0]
          : this.marqueeElements[this.currentIndex + 1];

      element.classList.add('animate-out');
      element.classList.remove('animate-in');

      setTimeout(() => {
        element.style.display = 'none';
        element.classList.remove('animate-out');
      }, 450);

      nextElement.classList.add('animate-in');

      this.currentIndex += 1;

      if (this.currentIndex == this.marqueeElements.length) {
        this.currentIndex = 0;
      }
    }
  }

  customElements.define('marquee-block', MarqueeBlock);
  } catch(e) { console.error(e); }
})();

})();
